var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 23,
    viewBox: "0 0 53 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4377 1.3879H22.4377C22.4377 1.3879 22.4377 1.38789 22.4377 1.38788C22.4377 1.38789 22.4377 1.3879 22.4377 1.3879ZM24.5055 6.46458V6.58188C24.5056 6.56235 24.5057 6.5428 24.5057 6.52323C24.5057 6.50367 24.5056 6.48412 24.5055 6.46458ZM22.4391 11.6571H22.4375C22.4375 11.6576 22.4376 11.6581 22.4376 11.6587C22.4381 11.6581 22.4386 11.6576 22.4391 11.6571ZM10.3614 7.46724V5.57981C8.37801 4.67092 7.01069 3.14553 6.80049 1.38672C5.5035 2.80608 4.73145 4.58815 4.73145 6.52323C4.73145 8.45835 5.50353 10.2404 6.80055 11.6598C7.01096 9.90122 8.3782 8.37603 10.3614 7.46724Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.49414,
    y: 4.3877,
    width: 13.9468,
    height: 4.26185,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9844 23.0005C22.0166 23.0008 22.0489 23.001 22.0812 23.001C22.1136 23.001 22.1459 23.0008 22.1781 23.0005H21.9844ZM22.4401 22.9944C27.0664 22.8257 30.8459 19.4082 31.4767 14.9998H27.263C26.7088 17.1532 24.8164 18.7391 22.567 18.7391C22.5246 18.7391 22.4823 18.7386 22.4401 18.7375V22.9944ZM22.4401 8.65155C22.4823 8.65043 22.5246 8.64987 22.567 8.64987C24.6785 8.64987 26.4755 10.0474 27.1462 11.9998H31.4124C30.6211 7.78106 26.9292 4.55828 22.4401 4.39453V8.65155Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59168 18.7393H1.01135L5.00671 22.8504C5.04635 22.8912 5.05877 22.9494 5.04398 23.0011H5.62334L1.62873 18.8907C1.58889 18.8497 1.57654 18.7911 1.59168 18.7393ZM5.93234 23.0011H6.51064L2.51603 18.8907C2.4762 18.8497 2.46385 18.7911 2.47898 18.7393H1.89971L5.89507 22.8504C5.93471 22.8912 5.94713 22.9494 5.93234 23.0011ZM0 18.7393H0.703318C0.688183 18.7911 0.700533 18.8497 0.740369 18.8907L4.73498 23.0011H4.12911L0 18.7523V18.7393ZM6.81964 23.0011H22.4417V18.7393H2.78702L6.78237 22.8504C6.82201 22.8912 6.83443 22.9494 6.81964 23.0011ZM0 23.0011V22.9891L0.0116721 23.0011H0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6866 11.5868L34.6885 11.5848C34.6878 11.5842 34.687 11.5836 34.6863 11.583C34.6864 11.5842 34.6865 11.5855 34.6866 11.5868ZM45.2444 6.64811L46.5409 7.9822C48.4265 7.32717 50.3442 7.51115 51.6865 8.61721C51.5358 6.7651 50.802 4.99993 49.4722 3.63162C48.1426 2.26345 46.4274 1.50842 44.6276 1.35316C45.7024 2.73455 45.8811 4.70785 45.2444 6.64811Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4174 12H44.2748L48.5479 7.60303L45.6192 4.58945L38.4174 12ZM41.3593 15L39.5756 16.8354L37.7919 15L41.3593 15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5403 21.9161L44.8742 22.2586C44.8991 22.2406 44.9297 22.2301 44.9628 22.2303L50.7222 22.2624L50.3138 21.8434C50.2943 21.9041 50.2373 21.9478 50.1702 21.9475L44.5403 21.9161ZM44.2744 21.6433C44.2992 21.6254 44.3298 21.6149 44.3628 21.6151L50.1225 21.6472L49.7144 21.2285C49.6945 21.2885 49.6378 21.3315 49.5712 21.3312L43.9395 21.2998L44.2744 21.6433ZM43.7638 20.9988L49.5218 21.0309L43.6432 15.0001H37.7988L43.6744 21.0278C43.6994 21.0094 43.7304 20.9986 43.7638 20.9988ZM45.5599 22.9621L45.1399 22.5313L50.7702 22.5627C50.8372 22.563 50.8942 22.5194 50.9137 22.4589L51.3691 22.9261L51.334 22.9621H45.5599ZM40.7189 12.0001L39.5755 10.8271L38.4322 12.0001H40.7189Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5723 13.5715C16.5723 12.655 17.3152 11.9121 18.2316 11.9121H18.5289C19.4453 11.9121 20.1882 12.655 20.1882 13.5715C20.1882 14.4879 19.4453 15.2309 18.5289 15.2309H18.2316C17.3152 15.2309 16.5723 14.4879 16.5723 13.5715Z",
    fill: "url(#paint0_linear_274_10)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9276 14.3067C15.6023 14.0715 15.4396 13.954 15.3894 13.8038C15.3552 13.7017 15.3552 13.5907 15.3894 13.4877C15.4396 13.3364 15.6023 13.2148 15.9276 12.9718V12.9718C16.3778 12.6354 16.6029 12.4672 16.7914 12.4819C16.9186 12.4919 17.0365 12.5501 17.121 12.6447C17.2464 12.7851 17.2464 13.0644 17.2464 13.6232V13.6232C17.2464 14.182 17.2464 14.4613 17.121 14.6047C17.0365 14.7014 16.9186 14.7625 16.7914 14.7755C16.6029 14.7948 16.3778 14.6321 15.9276 14.3067V14.3067Z",
    fill: "url(#paint1_linear_274_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_274_10",
    x1: 18.3803,
    y1: 11.9121,
    x2: 18.3803,
    y2: 15.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#FFE91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6CC76",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_274_10",
    x1: 15.0195,
    y1: 13.6503,
    x2: 17.2464,
    y2: 13.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6CC76",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.67dfd5491cb2a1c867b38c4a0051cbf7.svg";
export { ForwardRef as ReactComponent };